<template>
  <v-dialog v-model="dialog" persistent width="800">
    <common-card>
      <v-card-text class="pa-4 black--text">
        <!-- Título -->
        <div
          class="pt-5 pb-5 top-text"
          style="width:100%; justify-content:center; text-align:center;"
        >
          Crear Membresía
        </div>

        <!-- Formulario principal -->
        <div v-if="!resultado" class="pt-3 pb-3">
          <v-form ref="form">
            <v-row>
              <v-col cols="12" md="4">
                <v-text-field
                  label="Nombre"
                  outlined
                  v-model.trim="request.nombre"
                  color="#00a7e4"
                  :rules="requiredRule"
                  clearable
                />
              </v-col>

              <v-col cols="12" md="4">
                <v-text-field
                  label="Primer apellido"
                  outlined
                  v-model.trim="request.primer_apellido"
                  color="#00a7e4"
                  :rules="requiredRule"
                  clearable
                />
              </v-col>

              <v-col cols="12" md="4">
                <v-text-field
                  label="Segundo apellido"
                  outlined
                  v-model.trim="request.segundo_apellido"
                  color="#00a7e4"
                  clearable
                />
              </v-col>

              <v-col cols="12" md="4">
                <v-text-field
                  label="Fecha de nacimiento (dd/mm/aaaa)"
                  outlined
                  v-model.trim="request.fecha_nacimiento"
                  color="#00a7e4"
                  :rules="fechaRule"
                  placeholder="dd/mm/aaaa"
                  clearable
                />
              </v-col>

              <v-col cols="12" md="4">
                <v-text-field
                  label="Celular"
                  outlined
                  v-model.trim="request.celular"
                  color="#00a7e4"
                  :rules="requiredRule"
                  clearable
                />
              </v-col>

              <v-col cols="12" md="4">
                <v-text-field
                  label="Correo electrónico"
                  outlined
                  v-model.trim="request.email"
                  color="#00a7e4"
                  :rules="emailRule"
                  clearable
                />
              </v-col>

              <v-col cols="12" md="4">
                <v-autocomplete
                  label="Plan"
                  outlined
                  :items="planesItems"
                  v-model="request.plan"
                  color="#00a7e4"
                  :rules="requiredRule"
                  clearable
                />
              </v-col>
            </v-row>
          </v-form>
        </div>

        <!-- Resultado exitoso (status 1) -->
        <div v-if="resultado && resultado.ok" class="pt-5 pb-5 text-center">
          <v-icon color="success" size="60">mdi-check-circle-outline</v-icon>
          <div
            class="mt-3 mb-4"
            style="font-size:16px; font-weight:600; color:#4d5358;"
          >
            ¡Membresía creada exitosamente!
          </div>
          <v-btn
            color="#00a7e4"
            dark
            style="border-radius:15px;"
            :href="resultado.liga_membrecia"
            target="_blank"
          >
            <v-icon left>mdi-open-in-new</v-icon>
            Ir a la membresía
          </v-btn>
        </div>

        <!-- Resultado error pefai (status 2) -->
        <div
          v-if="resultado && !resultado.ok && resultado.status === 2"
          class="pt-5 pb-5 text-center"
        >
          <v-icon color="warning" size="60">mdi-cloud-off-outline</v-icon>
          <div class="mt-3" style="font-size:15px; color:#4d5358;">
            Error de membresía, actualmente el servicio está caído. Intente
            nuevamente en unos segundos.
          </div>
        </div>

        <!-- Resultado error nuestro (status 3) -->
        <div
          v-if="resultado && !resultado.ok && resultado.status === 3"
          class="pt-5 pb-5 text-center"
        >
          <v-icon color="error" size="60">mdi-alert-circle-outline</v-icon>
          <div class="mt-3" style="font-size:15px; color:#4d5358;">
            Contactar con soporte para validar el error.
          </div>
        </div>

        <!-- Botones -->
        <div>
          <v-row style="text-align:end;">
            <v-col cols="12">
              <v-btn
                text
                color="#00a7e4"
                outlined
                dark
                style="border-radius:15px;"
                @click="$emit('closeModal')"
                :disabled="loading"
              >
                {{ resultado ? "Cerrar" : "Cancelar" }}
              </v-btn>

              <v-btn
                v-if="!resultado"
                class="common-botton ml-3"
                dark
                :loading="loading"
                @click="submit"
              >
                Crear membresía
              </v-btn>
            </v-col>
          </v-row>
        </div>
      </v-card-text>
    </common-card>
  </v-dialog>
</template>

<script>
import CommonCard from "@/components/commonComponents/CommonCard.vue";
import { mainAxios } from "@/mainAxios.js";

export default {
  name: "MembresiaXsellModal",

  components: {
    CommonCard,
  },

  props: {
    dialog: { type: Boolean, required: true },
    clienteInfo: { type: Object, default: () => ({}) },
  },

  data() {
    return {
      loading: false,
      resultado: null,

      request: {
        nombre: "",
        primer_apellido: "",
        segundo_apellido: "",
        fecha_nacimiento: "",
        celular: "",
        email: "",
        plan: null,
      },

      planesItems: ["INTER+"],

      requiredRule: [
        (v) =>
          (v !== null && v !== undefined && String(v).trim() !== "") ||
          "El campo es requerido",
      ],

      fechaRule: [
        (v) =>
          (v !== null && v !== undefined && String(v).trim() !== "") ||
          "El campo es requerido",
        (v) =>
          /^\d{2}\/\d{2}\/\d{4}$/.test(v) || "Formato inválido, use dd/mm/aaaa",
      ],

      emailRule: [
        (v) =>
          (v !== null && v !== undefined && String(v).trim() !== "") ||
          "El campo es requerido",
        (v) => /.+@.+\..+/.test(v) || "Correo inválido",
      ],
    };
  },

  watch: {
    // Cuando se abre el modal, precarga los datos del cliente
    dialog(val) {
      if (val) {
        this.resultado = null;
        this.$nextTick(() => {
          this.$refs.form && this.$refs.form.resetValidation();
        });
        this.prefillFromCliente();
      }
    },
  },

  methods: {
    prefillFromCliente() {
      const c = this.clienteInfo;
      if (!c) return;

      this.request.nombre = c.nombre || "";
      this.request.primer_apellido = c.apellidoPaterno || "";
      this.request.segundo_apellido = c.apellidoMaterno || "";
      this.request.celular = c.telefonoMovil || "";
      this.request.email = c.correo || "";
      this.request.plan = null;

      // Convierte fechaNacimiento de yyyy-MM-dd → dd/mm/aaaa
      if (c.fechaNacimiento) {
        const partes = c.fechaNacimiento.split("-");
        if (partes.length === 3) {
          this.request.fecha_nacimiento = `${partes[2]}/${partes[1]}/${partes[0]}`;
        }
      }
    },

    async submit() {
      const valid = this.$refs.form.validate();
      if (!valid) return;

      this.loading = true;
      try {
        const config = {
          headers: {
            Authorization: "Bearer " + localStorage.agenteAccessToken,
          },
        };

        const { data } = await mainAxios.post(
          "/v1/membresia/xsell",
          this.request,
          config,
        );
        this.resultado = data;
      } catch (e) {
        // Si el backend respondió con un body de error lo mostramos como status 3
        this.resultado = {
          ok: false,
          status: 3,
          error: e?.response?.data?.message || e.message,
        };
      } finally {
        this.loading = false;
      }
    },
  },

  mounted() {
    if (this.dialog) {
      this.prefillFromCliente();
    }
  },
};
</script>

<style scoped>
.top-text {
  height: 22px;
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 110%;
  display: flex;
  align-items: center;
  text-align: center;
  color: #4d5358;
}
</style>
